import { getLanguageByBasename } from "../../../helpers/routingHelpers";
import { IntlProvider } from "react-intl";
import { useLanguageTranslations } from "../hooks/translations";

export const LocalizationProvider = ({ children }) => {
  const language = getLanguageByBasename();
  const messages = useLanguageTranslations(language.key);

  return (
    <IntlProvider
      locale={language.key}
      key={language.key}
      messages={messages}
    >
      {children({ messages, language })}
    </IntlProvider>
  )
}